export default __webpack_public_path__ + "assets/images/42d94421b3badbbf1d9c101448b136f7.svg";